// Message clustering and positioning utilities

export const MESSAGE_POSITIONS = {
  SINGLE: 'single',
  FIRST: 'first',
  MIDDLE: 'middle',
  LAST: 'last',
};

/**
 * Determines if two messages should be clustered together
 * Messages cluster if from same sender and within 2 minutes
 */
export const shouldClusterMessages = (currentMsg, previousMsg) => {
  if (!previousMsg) return false;
  if (currentMsg.sender_id !== previousMsg.sender_id) return false;

  const timeDiff = new Date(currentMsg.created_at) - new Date(previousMsg.created_at);
  return timeDiff <= 120000; // 2 minutes
};

/**
 * Determines the position of a message in a cluster
 * Returns: 'single', 'first', 'middle', or 'last'
 */
export const getMessagePosition = (messages, index) => {
  const current = messages[index];
  const previous = messages[index - 1];
  const next = messages[index + 1];

  const clusterWithPrevious = shouldClusterMessages(current, previous);
  const clusterWithNext = shouldClusterMessages(next, current);

  if (!clusterWithPrevious && !clusterWithNext) return MESSAGE_POSITIONS.SINGLE;
  if (!clusterWithPrevious && clusterWithNext) return MESSAGE_POSITIONS.FIRST;
  if (clusterWithPrevious && clusterWithNext) return MESSAGE_POSITIONS.MIDDLE;
  if (clusterWithPrevious && !clusterWithNext) return MESSAGE_POSITIONS.LAST;

  return MESSAGE_POSITIONS.SINGLE;
};

/**
 * Format timestamp for message display
 */
export const formatMessageTime = (timestamp) => {
  return new Date(timestamp).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
};

/**
 * Format timestamp for chat list preview
 */
export const formatChatListTime = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 7) return `${diffDays}d`;

  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
